export default {
  props: {
    dropdown: {
      type: Boolean,
      default: false
    },

    inline: {
      type: Boolean,
      default: false
    },

    nullable: {
      type: Boolean,
      default: false
    },

    value: {
      type: Boolean,
      default: undefined
    },
  }
};
